import { render, staticRenderFns } from "./white.edit.vue?vue&type=template&id=155ea1a5&scoped=true"
import script from "./white.edit.vue?vue&type=script&lang=js"
export * from "./white.edit.vue?vue&type=script&lang=js"
import style0 from "./white.edit.vue?vue&type=style&index=0&id=155ea1a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ea1a5",
  null
  
)

export default component.exports